import Model from 'models/Model';
import Product from '../product/Model.Product';
import refundConfigTemplateDeleteApi from './delete/Api.RefundConfigTemplate.Delete';
import refundConfigTemplateListApi from './list/Api.RefundConfigTemplate.List';
import refundConfigTemplateSaveApi from './save/Api.RefundConfigTemplate.Save';

export default class RefundConfigTemplate
  extends Model<Model.IRefundConfigTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IRefundConfigTemplate>
{
  id: number;
  internalName: string;
  isEnabled: boolean;
  cancellationPeriodThresholdDays: number;
  isLienHolderApplicable: boolean;
  minimumRetainedPremium?: number;
  requiresCurrentOdometerReading: boolean;
  prorateRemainingTimeOrKmAtRisk: boolean;
  maximumKmApplies: boolean;
  administrationFee?: number;
  administrationFeeTax?: number;
  dealerProtectProfitAmount?: number;
  dealerProtectProfitExpirationDays: number;
  isCancellationLetterRequired: boolean;
  isInvoiceRequired: boolean;
  products?: Product[];
  masterTemplatesRefundType: Record<string, string>;
  insurersRefundType: Record<string, string>;
  surchargesRefundType: Record<string, string>;

  constructor(
    data: Partial<Model.IRefundConfigTemplate> | Utils.FormData<Model.IRefundConfigTemplate>,
    language?: Locale.Languages
  ) {
    super({ products: [Product] }, language);
    this.update(data);
  }

  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.internalName || this.id.toString(),
      subtitle: `Cancellation Period: ${this.cancellationPeriodThresholdDays.toString()}`,
      info: `Enabled: ${this.isEnabled ? 'Yes' : 'No'}`,
    };
  }

  static async list(body?: Api.Core.RefundConfigTemplate.List.IRequest) {
    const { payload, ...rest } = await refundConfigTemplateListApi(body);

    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new RefundConfigTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await refundConfigTemplateSaveApi(this);
  }
  async delete() {
    return await refundConfigTemplateDeleteApi(this.id);
  }
}
